import React from 'react';

const RouterHealthBadge = ({ isOnline }) => (
  <span
    className={`inline-flex items-center rounded border px-2 py-0.5 text-[11px] font-semibold ${
      isOnline
        ? 'border-emerald-400/50 bg-emerald-500/10 text-emerald-200'
        : 'border-rose-400/50 bg-rose-500/10 text-rose-200'
    }`}
  >
    {isOnline ? 'ONLINE' : 'OFFLINE'}
  </span>
);

export default RouterHealthBadge;
